module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-ebf270a39d6b7b403988c8e071eabb51.svg";